<!--单位信息模块-->
<template>
	<div class="workStateBody usePowerUnitDiv">
		<div class="topLeftTitleContent">运行情况</div>
		<div class="workStateContent bodyBorder">
			<div class="workStateLeft">
				<div class="workStateLeftTop">
					<p>安全运行:<span style="letter-spacing: 0rem;min-width: 30px;display: inline-block;text-align: center;"> {{safetyDate}}
						</span>天</p>
					<p>服务到期:<span style="letter-spacing: 0rem;min-width: 30px;display: inline-block;text-align: center;"> {{haveDate}}
						</span>天</p>
				</div>
				<div class="workStateLeftBottom">
					<div class=" usePowerUnitBlock" style="width: 97%; height: 72px;">
						<p class="usePowerUnitBoxTitle">总告警数</p>
						<p class="usePowerUnitBoxInfo special">{{earlyWarning+alarm}}</p>
					</div>
					<div class=" usePowerUnitBlock" style="width: 47%;margin-top: .05rem;">
						<p class="usePowerUnitBoxTitle">预警</p>
						<p class="usePowerUnitBoxInfo" style="height: 20px;line-height: 20px;">{{earlyWarning}}</p>
					</div>
					<div class=" usePowerUnitBlock" style="width: 47%;margin-top: .05rem;margin-left: .05rem;">
						<p class="usePowerUnitBoxTitle">告警</p>
						<p class="usePowerUnitBoxInfo" style="height: 20px;line-height: 20px;">{{alarm}}</p>
					</div>
				</div>
			</div>
			<div class="workStateRigth">
				<div class="workStatebuttonLine">
					<div class="workStatebuttonLineChild workStatebuttonLineChildValue">
						<p>{{unConfirmedAlarm}}</p>
						<p>{{monthEvent}}</p>
					</div>
					<div class="workStatebuttonLineChild workStatebuttonLineChildKey">
						<p>未确认告警</p>
						<p>本月告警数</p>
					</div>
					<div class="workStatebuttonLineChild">
						<div style="width: 50%;background-color: #FF9900;height: .15rem;"></div>
						<div style="width: 50%;background-color: #DDDDDD;height: .15rem;"></div>
					</div>
				</div>
				<div class="workStateRigthBottom">
					<div class=" usePowerUnitBlock" style="width: 25%;">
						<p class="usePowerUnitBoxTitle">上月同期</p>
						<p class="usePowerUnitBoxInfo">{{lastMonthEvent}}</p>
					</div>
					<div class=" usePowerUnitBlock" style="width: 20%;">
						<p class="usePowerUnitBoxTitle">环比增长</p>
						<p class="usePowerUnitBoxInfo">{{ringRatio}} %</p>
					</div>
					<div class=" usePowerUnitBlock" style="width: 20%;">
						<p class="usePowerUnitBoxTitle">去年同期</p>
						<p class="usePowerUnitBoxInfo">{{lastYearMonthEvent}}</p>
					</div>
					<div class=" usePowerUnitBlock" style="width: 20%;">
						<p class="usePowerUnitBoxTitle">同比增长</p>
						<p class="usePowerUnitBoxInfo">{{getOnYear}} %</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: [],
		data() {
			return {
				saveUnitInfo: {
					checkCompleted: 0,
					checkPlan: 0,
				},
				noAlarm: 0,
				alarm: 0,
				unConfirmedAlarm: 0, //未确认告警
				earlyWarning: 0,
				monthEvent: 0,
				lastYearMonthEvent: 0, //上年本月
				lastMonthEvent: 0, //上月事件
			}
		},
		created() {
		},
		mounted() {
			addNewTask('refreshWorkStateNoWork',0,5*60*1000,-1,()=>{
				this.initData()
				this.eventListData()
			})
		},
		destroyed() {
			removeTask('refreshWorkStateNoWork')
		},
		computed: {
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			getOnYear() {
				//同比
				if (this.lastYearMonthEvent != 0) {
					return ((this.monthEvent - this.lastYearMonthEvent) * 100 / this.lastYearMonthEvent).toFixed(2)
				}
				return 0
			},
			ringRatio() {
				if (this.lastMonthEvent != 0) {
					return parseFloat(((this.monthEvent - this.lastMonthEvent) * 100 / this.lastMonthEvent).toFixed(2))
				}
				return 0
			},
			safetyDate() {
				return Math.floor((Date.now() - this.nowUnit.joinTime) / (24 * 3600 * 1000))
			},
			haveDate() {
				return Math.floor((this.nowUnit.expirationTime - Date.now()) / (24 * 3600 * 1000))
			}

		},
		watch: {
			saveUnitInfo(nv, ov) {},
			nowUnit(nv, ov) {
				this.initData()
				this.eventListData()
			}
		},
		methods: {
			initData() {
				if (isempty(this.nowUnit)) {
					setTimeout(() => {
						this.initData()
					}, 100)
					return
				}
				this.$api.unitApi.getUnitInfo(this.nowUnit.id, respon => {
					if (respon != null) {
						this.saveUnitInfo = respon
					} else {
						this.saveUnitInfo = {
							checkCompleted: 0,
							checkPlan: 0,
						}
					}
				})
			},
			isemptyUndefined(data) {
				if (data == undefined) {
					return 0
				}
				return data
			},
			eventListData() {
				var today = new Date()
				var year = today.getFullYear()
				var month = today.getMonth()
				var day = today.getDate()
				var todayTime = today.getTime()
				//本月未确认告警
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, '', 0, '2', '', new Date(year, month, 1).getTime(),
					todayTime, '', respon => {
						this.unConfirmedAlarm = 0
						if (!isempty(respon)) {
							Object.keys(respon).forEach(key => {
								this.unConfirmedAlarm += respon[key]
							})
						}
					})
				//预警
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, '', -1, '1', '', 0, todayTime, '', respon => {
					this.earlyWarning = 0
					if (!isempty(respon)) {
						Object.keys(respon).forEach(key => {
							this.earlyWarning += respon[key]
						});
					}
				})
				//告警
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, '', -1, '2', '', 0, todayTime, '', respon => {
					this.alarm = 0
					if (!isempty(respon)) {
						Object.keys(respon).forEach(key => {
							this.alarm += respon[key]
						});
					}
				})
				//本月事件
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, '', -1, '', '', new Date(year, month, 1).getTime(),
					todayTime, '', respon => {
						this.monthEvent = 0
						if (!isempty(respon)) {
							Object.keys(respon).forEach(key => {
								this.monthEvent += respon[key]
							});
						}
					})
				//去年本月事件
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, '', -1, '', '', new Date(year - 1, month, 1).getTime(),
					new Date(year -
						1, month + 1, 1).getTime() - 1, '', respon => {
						this.lastYearMonthEvent = 0
						if (!isempty(respon)) {
							Object.keys(respon).forEach(key => {
								this.lastYearMonthEvent += respon[key]
							});
						}
					})
				//上月事件数
				this.$api.eventApi.countEventListByUser('', this.nowUnit.id, '', -1, '', '', new Date(year, month - 1, 1).getTime(),
					new Date(year,
						month, 1).getTime() - 1, '', respon => {
						this.lastMonthEvent = 0
						if (!isempty(respon)) {
							Object.keys(respon).forEach(key => {
								this.lastMonthEvent += respon[key]
							});
						}
					})
			},
			getPreMonth(date) {
				var arr = date.split('-');
				var year = arr[0];
				var month = arr[1];
				var day = arr[2];
				var days = new Date(year, month, 0);
				days = days.getDate();
				var year2 = year;
				var month2 = parseInt(month) - 1;
				if (month2 == 0) {
					year2 = parseInt(year2) - 1;
					month2 = 12;
				}
				var day2 = day;
				var days2 = new Date(year2, month2, 0);
				days2 = days2.getDate();
				if (day2 > days2) {
					day2 = days2;
				}
				if (month2 < 10) {
					month2 = '0' + month2;
				}
				var t2 = year2 + '-' + month2
				return t2;
			},
			upOrDown(data) {
				if (data > 0) {
					return this.getResourcesByName('unitInfo/up.png')
				} else if (data < 0) {
					return this.getResourcesByName('unitInfo/down.png')
				} else {
					return ''
				}
			}
		}
	}
</script>

<style scoped>
	@import url("../../components/css/usePowerUnit.css");

	.workStateBody {
		height: 274px;

	}

	.workStateBody .workStateContent {
		display: flex;
		align-items: center;
		justify-content: space-around;
		height: calc(100% - 31px);
	}

	.workStateBody .workStateLeft {
		width: 20%;
		height: 90%;
	}

	.workStateBody .workStateLeft .workStateLeftTop {
		width: 100%;
		height: 38%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}

	.workStateBody .workStateLeft .workStateLeftTop p {
		color: #999999;
		letter-spacing: .01rem;
		line-height: .3rem;
	}

	.workStateBody .workStateLeft .workStateLeftBottom {
		display: flex;
		align-content: center;
		flex-wrap: wrap;
		width: 100%;
		height: 62%;
		justify-content: center;
	}

	.workStateBody .workStateRigthBottom {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}

	.workStateBody .workStateRigth {
		width: 70%;
		height: 90%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.workStateBody .workStateRigth .workStatebuttonLine {
		width: 100%;
		height: 50%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
	}

	.workStateBody .workStateRigth .workStatebuttonLine .workStatebuttonLineChild {
		display: flex;
		align-items: center;
		justify-content: space-around;
		width: 100%;
	}

	.workStateBody .workStateRigth .workStatebuttonLine .workStatebuttonLineChildValue span {
		color: #FF3300;
		font-size: 20px;
		font-weight: 600;
	}

	.workStateBody .workStateRigth .workStateRigthBottom {
		width: calc(100% - 10px);
		height: 50%;
		display: flex;
		align-items: center;
		padding: 0 4px;
	}

	.workStateBody .workStateRigth .workStateRigthBottom .workStateRigthBottomNone {
		height: 81%;
		width: 20%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-around;
		background: none;
		border: 1px solid #ccc;
	}

	.workStateBody .workStateRigth .workStateRigthBottom .workStateRigthBottomTwo {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		width: 78%;
		justify-content: space-around;
		height: 90%;
	}

	.workStateBody .workStateRigth .workStateRigthBottom .workStateRigthBottomTwo .workStateRigthBottomTwoChild {
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: space-around;
		height: 40%;
		background: none;
		border: 1px solid #ccc;
		width: 100%;
	}
</style>
